"use client";
import {
  createItemFile,
  deleteItem,
  fetchData,
  getOneItem,
  updateItemFile,
  updateItemJson,
} from "../../../../Api/hotelEndpoint";
import { createAsyncThunk } from "@reduxjs/toolkit";

/***------------- Get All Hotel Profile Data ------------- ***/
export const fetchHotelProfile = createAsyncThunk(
  "hotel/profile/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const { data, totalPages, totalItems } = await fetchData({
        endpoint: "hotel/profile/fetchAll",
        ...params,
      });
      return { data, totalPages, totalItems };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- update Hotel Profile - API ------------- ***/
export const updateHotelProfileOnOff = createAsyncThunk(
  "hotel/profile/update-booking-onoff",
  async (formData, { rejectWithValue }) => {
    try {
      const data = await updateItemJson({
        endpoint: "hotel/profile/update-booking-onoff",
        formData,
      });

      if (data) return formData;
      else throw new Error("Request failed");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- update Hotel Order - API ------------- ***/
export const updateHotelOrder = async (formData) => {
  try {
    const data = await updateItemJson({
      endpoint: "hotel/update-hotel-order",
      formData,
    });

    if (data) return formData;
    else throw new Error("Request failed");
  } catch (error) {
    throw error;
  }
};

/***------------- Get All Hotel Room Data ------------- ***/
export const fetchRoom = createAsyncThunk(
  "hotel/fetchRoom",
  async (params, { rejectWithValue }) => {
    try {
      const { data, totalPages, totalItems } = await fetchData({
        endpoint: "hotel/room/fetchAll",
        ...params,
      });
      return { data, totalPages, totalItems };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- update Room Order - API ------------- ***/
export const updateRoomOrder = async (formData) => {
  try {
    const data = await updateItemJson({
      endpoint: "hotel/update-room-order",
      formData,
    });

    if (data) return formData;
    else throw new Error("Request failed");
  } catch (error) {
    throw error;
  }
};

/***------------- Delete Hotel Room - API ------------- ***/
export const deleteHotelRoom = createAsyncThunk(
  "hotel/delete/room",
  async (deleteData, { rejectWithValue }) => {
    try {
      const { id } = await deleteItem({
        endpoint: "hotel/room",
        ...deleteData,
      });
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Delete-undo Hotel Room - API ------------- ***/
export const deleteUndoHotelRoom = createAsyncThunk(
  "hotel/delete-undo/room",
  async (deleteData, { rejectWithValue }) => {
    try {
      const { id } = await deleteItem({
        endpoint: "hotel/room",
        undo: true,
        ...deleteData,
      });
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Create Hotel Room - API ------------- ***/
export const createHotelRoom = async ({ formData }) => {
  try {
    const data = await createItemFile({
      endpoint: "hotel/room/create",
      formData,
      id: formData?.hotelId,
    });
    if (data) return data;
    else throw new Error("Request failed");
  } catch (err) {
    throw err;
  }
};

/***------------- update Hotel Room - API ------------- ***/
export const updateHotelRoom = async ({ formData }) => {
  try {
    const data = await updateItemFile({
      endpoint: `hotel/room/update/${formData?.hotelId}`,
      formData,
      id: formData?._id,
    });

    if (data) return data;
    else throw new Error("Request failed");
  } catch (err) {
    throw err;
  }
};

/***------------- Get One Hotel Room Data ------------- ***/
export const fetchOneHotelRoom = async ({ roomId }) => {
  try {
    const data = await getOneItem(`hotel/room/fetch/${roomId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

/***------------- Get One Hotel Profile Data ------------- ***/
export const fetchOneHotelProfile = async ({ id }) => {
  try {
    const data = await getOneItem(`hotel/profile/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

/***------------- update Hotel Profile - API ------------- ***/
export const updateHotelProfile = async (formData) => {
  try {
    const data = await updateItemFile({
      endpoint: "hotel/profile/update",
      formData,
      id: formData?._id,
    });

    if (data) return data;
    else throw new Error("Request failed");
  } catch (err) {
    throw err;
  }
};

/***------------- Get One Hotel Property Data ------------- ***/
export const fetchOneHotelProperty = async ({ id }) => {
  try {
    const data = await getOneItem(`hotel/property/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

/***------------- update Hotel Property - API ------------- ***/
export const updateHotelProperty = async ({ _id, ...formData }) => {
  try {
    const data = await updateItemFile({
      endpoint: "hotel/property/update",
      formData,
      id: formData?.hotelAdminID,
    });

    if (data) return data;
    else throw new Error("Request failed");
  } catch (err) {
    throw err;
  }
};

/***------------- room count date wise ------------- ***/
export const fetchAllRoomAvailability = async (selectedDate, propertyId) => {
  try {
    const { data } = await fetchData({
      endpoint: "hotel/fetchAllRoomAvailability",
      paginate: false,
      selectedDate,
      propertyId,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

/***------------- update room count date wise ------------- ***/
export const updateRoomAvailability = async (formData) => {
  try {
    const data = await updateItemJson({
      endpoint: "hotel/updateRoomAvailability",
      formData,
    });
    if (data) {
      return data;
    }
  } catch (error) {
    throw error;
  }
};

/***------------- update room Ret Management wise ------------- ***/
export const updateRoomRateManagement = async (formData) => {
  try {
    const data = await updateItemJson({
      endpoint: `hotel/updateRoomRateManagement`,
      formData,
    });
    if (data) {
      return data?.updatedDates;
    }
  } catch (error) {
    throw error;
  }
};

/***------------- Get All Labels Name ------------- ***/
export const fetchLabels = async (labelType) => {
  try {
    const { data } = await fetchData({
      endpoint: "hotel/fetchAllLabels",
      paginate: false,
      labelType,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

/***------------- Add Hotel Property Rules- API ------------- ***/
export const createHotelPropertyRules = async (formData) => {
  try {
    const data = await updateItemJson({
      endpoint: "hotel/addHotelPropertyRules",
      formData,
      id: formData?._id,
    });
    if (data) return data;
    else throw new Error("Request failed");
  } catch (err) {
    throw err;
  }
};

/***------------- update sold out live inventory ------------- ***/
export const updateSoldOutLiveInventory = async (formData) => {
  try {
    const data = await updateItemJson({
      endpoint: "hotel/updateSoldOutLiveInventory",
      formData,
    });
    if (data) {
      return data;
    }
  } catch (error) {
    throw error;
  }
};
